<template>
    <themed-modal
        name="contact-new"
        title="New Contact"
        size="lg"
        @closed="handleClosed"
    >
        <themed-form
            :fields="formFields"
            :model-value="contact"
            :errors="errors"
            layout="grid"
            :columns="3"
            @input="contact = $event"
        />

        <template #footer>
            <div class="modal-actions">
                <themed-button
                    variant="secondary"
                    @click="hideModal"
                >
                    Cancel
                </themed-button>
                <themed-button
                    variant="default"
                    :disabled="loading"
                    @click="createContact"
                >
                    {{ loading ? 'Creating...' : 'Create Contact' }}
                </themed-button>
            </div>
        </template>
    </themed-modal>
</template>

<script>
import { mapState } from 'vuex';
import ThemedModal from '../ThemedModal.vue';
import ThemedForm from '../form/ThemedForm.vue';
import ThemedButton from '../ThemedButton.vue';

export default {
    name: 'NewContactModal',
    
    components: {
        ThemedModal,
        ThemedForm,
        ThemedButton
    },

    props: {
        attachTo: {
            type: String,
            required: true
        },
        attachToId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            contact: {
                name: '',
                type: '',
                title: '',
                email: '',
                phone: '',
                extension: '',
                cell: '',
                fax: '',
                comments: '',
                attachTo: this.attachTo,
                attachToId: this.attachToId
            },
            errors: {},
            loading: false,
            formFields: [
                {
                    name: 'name',
                    type: 'input',
                    label: 'Name',
                    placeholder: 'Enter contact name',
                    required: true,
                    col: 1
                },
                {
                    name: 'type',
                    type: 'select',
                    label: 'Type',
                    placeholder: 'Select type',
                    options: [
                        { value: '', label: 'Select type' },
                        { value: 'Broker', label: 'Broker' },
                        { value: 'Owner', label: 'Owner' },
                        { value: 'Property Manager', label: 'Property Manager' },
                        { value: 'Municipality', label: 'Municipality' },
                        { value: 'Developer', label: 'Developer' },
                        { value: 'Other', label: 'Other' }
                    ],
                    col: 1
                },
                {
                    name: 'title',
                    type: 'input',
                    label: 'Title',
                    placeholder: 'Enter title',
                    col: 1
                },
                {
                    name: 'email',
                    type: 'input',
                    inputType: 'email',
                    label: 'Email',
                    placeholder: 'john@example.com',
                    col: 1
                },
                {
                    name: 'phone',
                    type: 'input',
                    inputType: 'tel',
                    label: 'Phone',
                    placeholder: '(555) 555-5555',
                    col: 1
                },
                {
                    name: 'extension',
                    type: 'input',
                    label: 'Ext.',
                    placeholder: '123',
                    col: 1
                },
                {
                    name: 'cell',
                    type: 'input',
                    inputType: 'tel',
                    label: 'Cell',
                    placeholder: '(555) 555-5555',
                    col: 1
                },
                {
                    name: 'fax',
                    type: 'input',
                    inputType: 'tel',
                    label: 'Fax',
                    placeholder: '(555) 555-5555',
                    col: 2
                },
                {
                    name: 'comments',
                    type: 'textarea',
                    label: 'Comments',
                    placeholder: 'Enter any additional comments',
                    rows: 4,
                    col: 3
                }
            ]
        };
    },

    computed: {
        ...mapState(['contacts'])
    },

    mounted() {
        console.log('NewContactModal mounted');
        console.log('Form fields:', this.formFields);
        console.log('Contact data:', this.contact);
    },

    methods: {
        hideModal() {
            this.$modal.hide('contact-new');
        },

        handleClosed() {
            this.contact = {
                name: '',
                type: '',
                title: '',
                email: '',
                phone: '',
                extension: '',
                cell: '',
                fax: '',
                comments: '',
                attachTo: this.attachTo,
                attachToId: this.attachToId
            };
            this.errors = {};
            this.loading = false;
        },

        createContact() {
            this.loading = true;
            this.errors = {};

            axios.post('/contacts', this.contact)
                .then((response) => {
                    this.$emit('contact-created', response.data.contact);
                    
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });

                    this.hideModal();
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response?.data?.errors) {
                        this.errors = error.response.data.errors;
                    }
                    
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response?.data?.message || 'Failed to create contact'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
